import { ExternalLink, ThumbsDown, ThumbsUp } from "lucide-react";
import { Button } from "../Button";
import { AvaliarMensagem } from "../../lib/hook/AvaliarMensagem";
import { useCallback, useState } from "react";
import WhatsappIcon from "../Icons/Whatsapp";
import { useChat, type Versions } from "../../context/ChatContext";
import { useSubMenu } from "../../SubMenuContext";
import obterWhatsApps from "../../api/ObterWhatsApps";
import { EmpreenderApps } from "../../lib/AppsArray";

const HelpComponent = () => {
    const { app } = useSubMenu();
    const { whatsappLink } = useChat();

    return (
        <>
            <div className="mb-2">
                <p>
                    Selecione um dos contatos abaixo e clique no botão para abrir o WhatsApp
                </p>
            </div>
            <div>
                <Button asChild>
                    <a href={whatsappLink} target="_blank" className="[&>svg]:!size-3">
                        {app ? `Suporte ${app}` : 'Entrar em contato com o suporte'}
                        <ExternalLink />
                    </a>
                </Button>
            </div>
        </>
    )
};

const Review = ({ idResposta, versions }: { idResposta: number; versions: Versions[] }) => {
    const { avaliarResposta } = AvaliarMensagem();
    const [avaliacao, setAvaliacao] = useState<number | null>(null);
    const { addUserMessage, sendSystemMsg, setWhatsappLink } = useChat();
    const { app } = useSubMenu();

    const handleAvaliar = useCallback(async (valor: number) => {
        if (avaliacao !== null) return;

        setAvaliacao(valor);

        if (valor === 1) {
            const matchApp = EmpreenderApps.find((a) =>
                a.tags.some((tag) => tag?.toLowerCase() === app?.toLowerCase())
            );
            if (!matchApp) return;

            const whatsapp = await obterWhatsApps(matchApp.slug);

            setWhatsappLink(`https://wa.me/${whatsapp?.dados[0].whatsapp}`);
        }

        avaliarResposta(idResposta, valor);
    },
        [avaliacao, idResposta]);

    const handleAjuda = () => {
        addUserMessage('Preciso de ajuda');

        sendSystemMsg(<HelpComponent />);

    };

    const hasMaisAjuda = versions.some(
        (v) => typeof v.content === 'string' && v.content.includes('Mais ajuda')
    );

    return (
        <div className="flex flex-row gap-1">
            <Button
                onClick={() => handleAvaliar(2)}
                size="icon"
                variant={avaliacao === 2 ? 'success' : 'ghost'}
            >
                <ThumbsUp />
            </Button>

            <Button
                onClick={() => handleAvaliar(1)}
                variant={avaliacao === 1 ? 'destructive' : 'ghost'}
                size="icon"
            >
                <ThumbsDown />
            </Button>

            {
                (avaliacao === 1 || hasMaisAjuda) && <Button variant={'success'} onClick={handleAjuda}><WhatsappIcon />Precisa de ajuda?</Button>
            }
        </div>
    );
};

export default Review;
